import {h, Component} from 'preact'
import {connect} from 'react-redux'

import reduce from '../reducers'
import * as actions from '../actions'

export default @connect(reduce, actions)
class OfflineBanner extends Component {
    constructor() {
        super()

        this.state = {
            isOffline: false
        }

        this.checkIsOnline = () => {
            this.setState({ isOffline : !navigator.onLine })
        }
    }

    componentDidMount() {
        let _this = this;
        function updateIndicator() {
            _this.setState({ isOffline : !navigator.onLine })
        }
        window.addEventListener('online', updateIndicator)
        window.addEventListener('offline', updateIndicator)
    }

    render (props, state) {
        return (state.isOffline ?
            <div class="offline-banner">
                <div class="message">Trying to reconnect. Please check your internet connection or contact your service provider.&nbsp;
                    <a onClick={this.checkIsOnline}>Retry now</a></div>
            </div> : '')
    }
}
